import { font, query } from '@design/templateFns';
import { ThemeFontName } from '@design/types';
import styled from 'styled-components';
import { TypographyProps } from '../types';
import { ReactNode } from 'react';

const StyledHeading = styled.div<{
  $desktopFont?: ThemeFontName;
  $tabletFont?: ThemeFontName;
  $mobileFont?: ThemeFontName;
}>`
  ${({ $desktopFont }) => ($desktopFont ? font($desktopFont) : '')};
  @media screen and (${query.below('desktop')}) {
    ${({ $tabletFont }) => ($tabletFont ? font($tabletFont) : '')};
  }
  @media screen and (${query.below('tablet')}) {
    ${({ $mobileFont }) => ($mobileFont ? font($mobileFont) : '')};
  }
`;

const StyledHeaderText = styled.span<{ $swatchColor?: string }>`
  display: inline;
  background-image: url("data:image/svg+xml,%3Csvg
    width='311'
    height='9'
    viewBox='0 0 311 9'
    fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cline y1='4.5' x2='311' y2='4.5'
    stroke='${({ $swatchColor }) => ($swatchColor ? '%23' + $swatchColor : '%23e9e5e2')}'
    strokeWidth='8'
    /%3E%3C/svg%3E");
  background-repeat: repeat-x;
  background-position: 0 76%;
  background-size: auto 4px;
  @media screen and (${query.atLeast('tablet')}) {
    background-size: auto 8px;
  }
`;

const Headline = ({
  as,
  children,
  desktopFont,
  tabletFont,
  mobileFont,
  swatch,
  swatchColor,
}: TypographyProps): ReactNode => {
  return (
    <StyledHeading
      as={as}
      $desktopFont={desktopFont}
      $tabletFont={tabletFont}
      $mobileFont={mobileFont}
    >
      {swatch ? (
        <StyledHeaderText $swatchColor={swatchColor}>{children}</StyledHeaderText>
      ) : (
        children
      )}
    </StyledHeading>
  );
};

export default Headline;
